/**
 * Sesión del usuario del personal (2026-10-06).
 *
 * El login (/api/auth/login) devuelve un token personal que se guarda como `device_token`
 * (el mismo header X-Device-Token que usan las tablets) y el `device_id` del acceso web.
 * Si el backend responde 401 (token vencido, contraseña cambiada o usuario dado de baja),
 * se cierra la sesión y vuelve el login.
 */
const CLAVES = ['device_id', 'device_token', 'usuario_email', 'usuario_nombre', 'usuario_admin']

export interface Sesion {
  email: string
  nombre: string | null
}

export function leerSesion(): Sesion | null {
  try {
    const email = localStorage.getItem('usuario_email')
    const token = localStorage.getItem('device_token')
    // un token viejo del demo (secreto compartido) no cuenta: hay que entrar con usuario
    if (!email || !token?.startsWith('u1.')) return null
    return { email, nombre: localStorage.getItem('usuario_nombre') }
  } catch {
    return null
  }
}

export function guardarSesion(r: { token: string; device_id: string; email: string; nombre?: string | null; admin?: boolean }) {
  localStorage.setItem('device_token', r.token)
  localStorage.setItem('device_id', r.device_id)
  localStorage.setItem('usuario_email', r.email)
  if (r.nombre) localStorage.setItem('usuario_nombre', r.nombre)
  else localStorage.removeItem('usuario_nombre')
  if (r.admin) localStorage.setItem('usuario_admin', '1')
  else localStorage.removeItem('usuario_admin')
}

/** 2026-10-10 — ve el tablero de uso (lo decide el backend en el login; /uso lo vuelve a verificar). */
export function esAdmin(): boolean {
  try {
    return leerSesion() !== null && localStorage.getItem('usuario_admin') === '1'
  } catch {
    return false
  }
}

export function cerrarSesion(recargar = true) {
  try {
    CLAVES.forEach((k) => localStorage.removeItem(k))
  } catch {
    /* sin storage */
  }
  if (recargar) window.location.reload()
}
